import { projectTourOntourSlice } from '../project-tour-ontour.slice';

export const setCurrentSequenceId =
  projectTourOntourSlice.actions.setCurrentSequenceId;
